export default {
  jumpUrlData: '/v3/third/url'
}
